var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"locale-changer"},_vm._l((_vm.langs),function(lang){return _c('div',{key:lang},[(_vm.$root.$i18n.locale !== lang.locale)?_c('a',{on:{"click":function($event){return _vm.$emit('input', lang.locale)}}},[_vm._v(_vm._s(lang.name))]):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }